var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("Select File Name")]),_c('div',{staticClass:"pl-5"},[_c('label',[_vm._v("Selected File: ")]),_c('a',{on:{"click":_vm.download}},[_vm._v(_vm._s(this.selectedFile[0] ? this.selectedFile[0].filename : ''))])]),_c('v-container',{attrs:{"fluid":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.files,"items-per-page":5,"footer-props":{
                showFirstLastPage: true,
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                prevIcon: 'mdi-minus',
                nextIcon: 'mdi-plus'
            }},on:{"click:row":_vm.handleFileSelect},model:{value:(_vm.selectedFile),callback:function ($$v) {_vm.selectedFile=$$v},expression:"selectedFile"}}),(!_vm.loading)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.contentHeaders,"items":_vm.contentsConverted,"items-per-page":25,"footer-props":{
                showFirstLastPage: true,
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                prevIcon: 'mdi-minus',
                nextIcon: 'mdi-plus'
            }}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }